var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_251)",
    filter: "url(#filter0_d_44_251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7149 0.909546C29.3098 0.909546 26.1223 2.52471 24 5.23089C21.8777 2.52462 18.6903 0.909546 15.2851 0.909546C9.06251 0.909546 4 6.21314 4 12.7323C4 17.837 6.90549 23.7415 12.6356 30.2816C17.0454 35.3146 21.8425 39.2116 23.2076 40.2861L23.9997 40.9095L24.7918 40.2862C26.157 39.2117 30.9543 35.3148 35.3641 30.2818C41.0944 23.7417 44 17.8371 44 12.7323C44 6.21314 38.9375 0.909546 32.7149 0.909546ZM33.4212 28.4133C29.794 32.553 25.8917 35.8995 23.9997 37.4418C22.1079 35.8995 18.2057 32.5529 14.5785 28.4132C9.38338 22.4837 6.63736 17.0613 6.63736 12.7323C6.63736 7.73676 10.5167 3.67256 15.2851 3.67256C18.423 3.67256 21.3204 5.46428 22.8467 8.34858L24 10.5282L25.1533 8.34858C26.6795 5.46437 29.5769 3.67256 32.7149 3.67256C37.4833 3.67256 41.3626 7.73667 41.3626 12.7323C41.3626 17.0615 38.6165 22.4839 33.4212 28.4133Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_44_251",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_44_251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_44_251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.2f1b007f3cf63b2892d6e8e3194b9b36.svg";
export { ForwardRef as ReactComponent };